export const MAX_VINS = 100;
export const FULL_VIN_LENGTH = 17;
export const PARTIAL_VIN_LENGTH = 6;

/** 'full' or 'partial' for a usable value; null for one that is neither. */
export type VinKind = 'full' | 'partial';

export interface VinEntry {
  value: string;
  kind: VinKind | null;
}

// VINs never use I, O or Q — they read too easily as 1 and 0.
const VIN_CHARS = '[A-HJ-NPR-Z0-9]';
const FULL_VIN = new RegExp(`^${VIN_CHARS}{${FULL_VIN_LENGTH}}$`);
const PARTIAL_VIN = new RegExp(`^${VIN_CHARS}{${PARTIAL_VIN_LENGTH}}$`);

export function classifyVin(raw: string): VinEntry {
  const value = raw.trim().toUpperCase();
  const kind = FULL_VIN.test(value) ? 'full' : PARTIAL_VIN.test(value) ? 'partial' : null;
  return { value, kind };
}

/**
 * Commas per the spec, but also whitespace and semicolons — a column pasted
 * from a spreadsheet is newline-separated.
 */
export function splitVins(text: string): string[] {
  return text.split(/[\s,;]+/).filter(Boolean);
}
